<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="w-full bg-primary items-center px-8 py-6 flex">
        <div>
          <p
            @click="handleback('cmsmanagement')"
            class="gap-2 cursor-pointer fsize14 mb-4 text-white flex items-center"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Smart Forms
          </h2>
          <p class="text-white pt-1 text-sm capitalize font-normal">
            Just set them & put your mind at ease
          </p>
        </div>
      </div>
    </div>

    <div class="smart-card">
      <div class="flex justify-between items-center mb-8">
        <div>
          <h1 class="text-black pt-1 text-2xl capitalize font-semibold">
            My Forms
          </h1>
          <p class="font-nornal text-737373 text-base">
            All your contact forms in one place
          </p>
        </div>

        <el-button class="bg-primary text-white font-semibold" round
          >Create New Form</el-button
        >
      </div>

      <div class="w-full cust-eltable">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="Date" width="180">
          </el-table-column>
          <el-table-column prop="name" label="Name" width="180">
          </el-table-column>
          <el-table-column prop="address" label="Address"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: "2016-05-03",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
        },
        {
          date: "2016-05-02",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
        },
        {
          date: "2016-05-04",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
        },
        {
          date: "2016-05-01",
          name: "Tom",
          address: "No. 189, Grove St, Los Angeles",
        },
      ],
    };
  },
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style scoped>
.smart-card {
  margin: 23px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  background: #fff;
  padding: 24px 31px;
  border: 1px solid #ddd;
}
.cust-eltable .el-table {
  border-radius: 6px;
  padding: 0px;
  background: #ddd;
}
</style>
